// extracted by mini-css-extract-plugin
export var cardHeader = "_kv-1";
export var contentCard = "_kv-0";
export var headerActions = "_kv-3";
export var reorderHandle = "_kv-5";
export var titleArea = "_kv-2";
export var titleAreaWithHandle = "_kv-4";